import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarMakerModalService {

  private selectedCarMakerSubject = new BehaviorSubject<any>(null);
  public selectedCarMaker$ = this.selectedCarMakerSubject.asObservable();

  constructor() { }

  setSelectedCarMaker(carMaker: any): void {
    this.selectedCarMakerSubject.next(carMaker);
  }

  getSelectedCarMaker(): any | null {
    return this.selectedCarMakerSubject.value;
  }

  clearSelectedCarMaker(): void {
    this.selectedCarMakerSubject.next(null);
  }
}
